import React from 'react';
import fr from 'facet-rest';
import {
  FDBox, FDPrimaryActionButton, FDSecondaryActionIconButton, FDStack,
} from '@facet-wealth/design';
import {
  TaxDashboardWizardWrapper,
} from 'Views/Page/Content/Modal/Layouts/TaxDashboardWizard/Components/TaxDashboardWizardWrapper';
import { dataAttrs } from 'Helpers/Testing';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMobileLayout from 'Hooks/useMobileLayout';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';

const Layout = () => {
  const { clearModalCollection } = useModalContext();
  const { onSubmit, saving } = useMetaLayoutContext();
  const { displayErrorMessage } = useSnackbarContext();
  const { loadPageContentLink } = usePageContentContext();
  const isMobile = useMobileLayout();

  const onClick = async () => {
    const response = await onSubmit();
    const [submittedResource] = response;

    const messagePageRel = submittedResource.withRelationship(
      fr.relationships.messagesPage.name,
      (rel) => {
        return rel;
      },
      () => {
        displayErrorMessage(null, 'Failed to create new message');
      },
    );

    loadPageContentLink(messagePageRel.link('related'));
    clearModalCollection();
  };

  return (
    <TaxDashboardWizardWrapper hideProgress customButtons>
      <FDStack direction={'column'} spacing={4}>
        <MetaControlField attr={'questionText'} {...dataAttrs('tax-dashboard-ask-an-expert-question-text')} />
        <MetaControlField attr={'subject'} {...dataAttrs('tax-dashboard-ask-an-expert-subject')} />
        <FDStack direction={'row'} spacing={2} alignItems={'center'} justifyContent={'center'} width={'100%'} paddingY={4}>
          <FDSecondaryActionIconButton
            icon={'keyboardArrowLeft'}
            {...dataAttrs('tax-dashboard-ask-an-expert-cancel-btn')}
            onClick={() => {
              clearModalCollection();
            }}
          />
          <FDBox minWidth={160} maxWidth={isMobile ? undefined : 240} width={'100%'}>
            <FDPrimaryActionButton
              label={'Continue'}
              onClick={onClick}
              loading={saving}
              isFullWidth
              {...dataAttrs('continue-btn')}
            />
          </FDBox>
        </FDStack>
      </FDStack>
    </TaxDashboardWizardWrapper>
  );
};

export default Layout;
